import { baseApi } from "./api";
import request from "../request";

export const supplierInfoApi = baseApi.injectEndpoints({
	endpoints: (build) => ({
		getSupplierInfo: build.query({
			query: ({ projectId, invoiceId, forceRefresh = false }) => ({
				url: `projects/${projectId}/invoices/${invoiceId}/supplier-info`,
				params: forceRefresh ? { forceRefresh: true } : undefined,
			}),
			providesTags: (_r, _e, { invoiceId }) => [
				{ type: "SupplierInfo", id: invoiceId },
			],
		}),
		saveSupplierInfo: build.mutation({
			query: ({ projectId, invoiceId, ...body }) => ({
				url: `projects/${projectId}/invoices/${invoiceId}/supplier-info`,
				method: "POST",
				body,
			}),
			invalidatesTags: (_r, _e, { invoiceId }) => [
				{ type: "SupplierInfo", id: invoiceId },
			],
		}),
	}),
});

export const {
	useGetSupplierInfoQuery,
	useSaveSupplierInfoMutation,
} = supplierInfoApi;

// ────────────────────────────────────────────────────────────────────────────
// Blob/PDF download - plain helper (DOM side-effects, doesn't fit RTK cache).
// ────────────────────────────────────────────────────────────────────────────

export const downloadSupplierInfoPdf = async (
	id,
	selectedSections,
	language = "de",
	invoiceOverviewFilter = "all",
	filename = null,
	includeComments = false,
	projectId,
) => {
	try {
		const config = {
			responseType: "blob",
			headers: {
				Accept: "application/pdf",
			},
		};

		const payload = {
			selectedSections,
			language,
			invoiceOverviewFilter,
			includeComments,
		};

		const response = await request.post(
			`projects/${projectId}/invoices/${id}/supplier-info/pdf`,
			payload,
			config,
		);

		const blob = new Blob([response], { type: "application/pdf" });
		const url = window.URL.createObjectURL(blob);
		const link = document.createElement("a");
		link.href = url;
		const downloadFilename = filename || `supplier-info-${id}.pdf`;
		const finalFilename = downloadFilename.endsWith(".pdf")
			? downloadFilename
			: `${downloadFilename}.pdf`;
		link.setAttribute("download", finalFilename);
		document.body.appendChild(link);
		link.click();
		link.remove();
		window.URL.revokeObjectURL(url);

		return response;
	} catch (error) {
		console.error("Error downloading PDF:", error);
		throw new Error(error?.message || "Error downloading PDF");
	}
};
